import {
  SET_REGISTRATION_LIST,
  SET_REGISTRATION_LIST_PAGE,
  SET_REGISTRATION_LIST_PAGE_SIZE,
  SET_REGISTRATION_LIST_PAGE_SIZE_TOTAL,
  SET_REGISTRATION_LIST_QUERY,
  SET_REGISTRATION_LIST_SEARCHING,
  SET_REGISTRATION_TABLELIST_QUERY,
  SET_REGISTRATIONE_EXPORTIN,
} from './mutation-types'
import api from '@/api'
import _ from 'lodash'
import { checkUserName } from '@/views/User/utils'

const initQuery = () => {
  return {
    pageNum: 1,
    pageSize: 50,
    userId: '',
    salesmanId: '',
    id: '',
    fileType: '',
    auditStatus: '',
    registerBuildStatus: '',
    payStatus: '',
    auditDay: '',
    startTime: +new Date(new Date().getFullYear(), new Date().getMonth() - 1, new Date().getDate()),
    endTime: +new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), 23, 59, 59),
  }
}
const state = {
  searching: false,
  exporting: false,
  initQuery: initQuery(),
  copyrightRegistrations: {
    list: [],
    listPageTotal: 0,
    query: initQuery(),
  },
}
const mutations = {
  [SET_REGISTRATION_LIST](state, payload) {
    state.copyrightRegistrations.list = payload
  },
  [SET_REGISTRATIONE_EXPORTIN](state, payload) {
    state.copyrightRegistrations.exporting = payload
  },
  [SET_REGISTRATION_LIST_PAGE](state, payload) {
    state.copyrightRegistrations.query.pageNum = payload
  },
  [SET_REGISTRATION_LIST_PAGE_SIZE](state, payload) {
    state.copyrightRegistrations.query.pageSize = payload
  },
  [SET_REGISTRATION_LIST_PAGE_SIZE_TOTAL](state, payload) {
    state.copyrightRegistrations.listPageTotal = payload
  },
  [SET_REGISTRATION_LIST_QUERY](state, payload) {
    state.copyrightRegistrations.query = {
      ...state.copyrightRegistrations.query,
      ...payload,
    }
  },
  [SET_REGISTRATION_LIST_SEARCHING](state, payload) {
    state.searching = payload
  },
  [SET_REGISTRATION_TABLELIST_QUERY](state, payload) {
    state.copyrightRegistrations.query = {
      ...state.copyrightRegistrations.query,
      ...payload.query,
    }
  },
}
const actions = {
  // 获取版权登记列表
  async setCopyrightRegistrationList({ commit, state }, payload) {
    try {
      let query = {}
      _.forIn(state.copyrightRegistrations.query, (v, k) => {
        if (v !== '') query[k] = v
      })
      let params = {
        ...query,
        pageNum: state.copyrightRegistrations.query.pageNum,
        pageSize: state.copyrightRegistrations.query.pageSize,
      }
      const { data: { items, total } } = await api.userApi.getCopyRightRegistrationList(params)
      commit(SET_REGISTRATION_LIST_SEARCHING, false)
      commit(SET_REGISTRATION_LIST_PAGE_SIZE_TOTAL, total)
      commit(SET_REGISTRATION_LIST, items)
    } catch (error) {
      commit(SET_REGISTRATION_LIST, [])
      commit(SET_REGISTRATION_LIST_PAGE_SIZE_TOTAL, 0)
    }
  },
  async changeCopyrightRegistrationListPage({ commit, state, dispatch }, payload) {
    commit(SET_REGISTRATION_LIST_PAGE, payload.currentPage)
    if (!payload.noXHR) await dispatch('setCopyrightRegistrationList')
  },
  initCopyrightRegistrationList({ commit, dispatch }) {
    let query = { pageNum: 1, pageSize: 50 }
    commit(SET_REGISTRATION_LIST_QUERY, query)
    dispatch('changeCopyrightRegistrationListPage', { currentPage: 1 })
  },
  changePageSize({ commit, dispatch }, payload) {
    commit(SET_REGISTRATION_LIST_SEARCHING, true)
    commit(SET_REGISTRATION_LIST_PAGE_SIZE, payload.listPageSize)
    dispatch('changeCopyrightRegistrationListPage', { currentPage: 1 })
  },
  changeQuery({ commit }, payload) {
    commit(SET_REGISTRATION_LIST_QUERY, payload)
  },
  // 列表表头筛选
  async filterQuery({ commit, dispatch }, payload) {
    commit(SET_REGISTRATION_TABLELIST_QUERY, payload)
    await dispatch('setCopyrightRegistrationList')
  },
  // 重置筛选参数
  resetCopyrightQuery({ commit }, payload) {
    commit(SET_REGISTRATION_TABLELIST_QUERY, payload)
  },
  // 导出
  async exportList ({commit, dispatch}, payload) {
    commit(SET_REGISTRATIONE_EXPORTIN, true)
    const res = await api.userApi.exportList(payload)
    const { data, code } = res
    checkUserName({
      code,
      data,
      callback: ({userId}) => {
        const { userName, ...other } = payload
        dispatch('exportList', {
          ...other,
          userId,
        })
      },
    })
    commit(SET_REGISTRATIONE_EXPORTIN, false)
    return res
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
